"use strict";exports.__esModule = true;exports.default = void 0;var _makeupActiveDescendant = require("makeup-active-descendant");
var _elementScroll = require("../../common/element-scroll");
var eventUtils = _interopRequireWildcard(require("../../common/event-utils"));function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || typeof obj !== "object" && typeof obj !== "function") {return { default: obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj.default = obj;if (cache) {cache.set(obj, newObj);}return newObj;}

class _default {
  get isAutoSelection() {
    return this.input.listSelection === 'auto';
  }

  elementScroll() {
    (0, _elementScroll.scroll)(this.getEls('option')[this.state.selectedIndex]);
  }

  handleChange(index, wasClicked) {
    if (this.state.selectedIndex !== index) {
      var option = this.input.options[index];
      this.state.selectedIndex = index;
      this.once('update', () => {
        this.emit('change', {
          index,
          wasClicked,
          selected: [option.value],
          el: this.getEls('option')[index] });

      });
    }
  }

  handleClick(index) {
    this.handleChange(index, true);
  }

  handleMouseDown() {
    this.wasClicked = true;
  }

  handleKeyDown(originalEvent) {
    eventUtils.handleEscapeKeydown(originalEvent, () => {
      this.emit('escape');
    });

    eventUtils.handleActionKeydown(originalEvent, () =>
    this.handleChange(this._activeDescendant.index, false));

  }

  handleListboxChange(event) {
    var selectedIndex = parseInt(event.detail.toIndex, 10);
    var el = this.getEls('option')[selectedIndex];
    var wasClicked = this.wasClicked;

    (0, _elementScroll.scroll)(el);

    if (this.wasClicked) {
      this.wasClicked = false;
    }
    this.handleChange(selectedIndex, wasClicked);
  }

  onCreate() {
    this.state = {
      selectedIndex: -1 };

  }

  onInput(input) {
    var { state } = this;
    input.options = input.options || [];
    state.selectedIndex = Math.max(
    -1,
    input.options.findIndex((option) => option.selected));

  }

  onMount() {
    this._setupMakeup();
  }

  onUpdate() {
    this._setupMakeup();
  }

  onRender() {
    if (typeof window !== 'undefined') {
      this._cleanupMakeup();
    }
  }

  onDestroy() {
    this._cleanupMakeup();
  }

  _setupMakeup() {
    var { input, state } = this;

    if (input.options.length && !input.disabled) {
      var container = this.getEl('options');
      var optionsContainer = this.getEl('options');
      this._activeDescendant = (0, _makeupActiveDescendant.createLinear)(
      container,
      optionsContainer,
      optionsContainer,
      '.listbox__option[role=option]',
      {
        activeDescendantClassName: 'listbox__option--active',
        autoInit: state.selectedIndex,
        autoReset: null,
        autoScroll: !this.isAutoSelection });


    }
  }

  _cleanupMakeup() {
    if (this._activeDescendant) {
      this._activeDescendant.destroy();
      this._activeDescendant = undefined;
    }
  }}exports.default = _default;module.exports = exports.default;